export enum TelephonyServerTypes {
    BROADWORKS = 'BroadSoft BroadWorks'
}

export enum TelephonyServerPartitionType {
    BROADWORKS_ENTERPRISE = 'BroadWorks Enterprise',
    BROADWORKS_SERVICE_PORIVIDER_GROUP = 'BroadWorks ServiceProvider Group'
}

export enum TelSysTypes {
    UNKNOWN = 'Unknown',
    SIMULATOR = 'Simulator',
    WEBEX_CALLING = 'Webex Calling',
    BROADSOFT_BROADWORKS = 'BroadSoft BroadWorks',
    SIEMENS_HIPATH_3000 = 'Siemens HiPath 3000',
    PANASONIC_TDA_NCP = 'Panasonic TDA/NCP',
    BROADSOFT_M6 = 'BroadSoft M6',
    MS_TEAMS = 'MS Teams'
}

export const TELEPHONY_SYSTEM_TYPE_UNKNOWN = -1 // Unknown.
export const TELEPHONY_SYSTEM_TYPE_VALID_MIN = 0 // Minimum value of range for valid values.
export const TELEPHONY_SYSTEM_TYPE_DUMMY = 0 // Dummy telephone module (does nothing).
export const TELEPHONY_SYSTEM_TYPE_SIMULATOR = 1 // Simulator telephone module.
export const TELEPHONY_SYSTEM_TYPE_BROADSOFT_M6 = 5 // Broadsoft M6 telephone module.
export const TELEPHONY_SYSTEM_TYPE_BROADSOFT_BROADWORKS = 7 // Broadsoft BroadWorks telephone module.
export const TELEPHONY_SYSTEM_TYPE_SYLANTRO_SYNERGY = 10 // Sylantro Synergy telephone module.
export const TELEPHONY_SYSTEM_TYPE_SIEMENS_HIPATH_3000 = 15 // Siemens HiPath 3000 telephone module.
export const TELEPHONY_SYSTEM_TYPE_PANASONIC_TDA_NCP = 20 // Panasonic TDA 30, 50 & 100, and additionally the NCP.
export const TELEPHONY_SYSTEM_TYPE_CISCO_WEBEX_CALLING = 25 // Cisco Webex Calling telephone module.
export const TELEPHONY_SYSTEM_TYPE_MS_TEAMS: number = 30 // MS Teams telephone module.
